<template>
    <div class="chat">
        <div class="title">
            <h3>AI客服</h3>
            <i class="el-icon-close close" @click="closeFn"></i>
        </div>
        <div class="lists" ref="lists">
            <div class="list " v-for="(item, index) in lists" :class="item.type == 'left' ? 'left-list' : 'right-list'">
                <div class="content">
                    <p class="name">{{ item.name }}</p>
                    <p class="text" v-if="item.text">{{ item.text }}</p>
                    <el-image  fit="contain" v-if="item.img" style="width: 100px; height: 100px"
                        :src="'http://www.newlegend.com.au/public' + item.img"
                        :preview-src-list="['http://www.newlegend.com.au/public' + item.img]">
                    </el-image>
                </div>
            </div>
        </div>
        <div class="context">
            <el-input v-model="text" placeholder="请输入您的问题"></el-input>
            <el-upload :disabled="answerState" ref="child1" class="upload-demo" accept='.png, .jpg'
                :action="host + '/VisApi/uploadImg'" :on-success="successReport1" :before-remove="removeReport1"
                :file-list="fileList" :before-upload="beforeAvatarUpload1" :on-exceed="onExceedFn1" :limit="1">
                <img src="@/assets/imgs/tupian.png" class="pic" alt="">
            </el-upload>
            <div class="btn" @click="subFn">发送</div>
            <div class="tips">
                <span @click="askFn(1)">留学咨询</span>
                <span @click="askFn(2)">签证咨询</span>
                <span @click="askFn(3)">其他</span>
            </div>
        </div>
    </div>
</template>
<script> 
export default {
    name: 'chat',
    data() {
        return {
            answerState: false,
            selectType: 0,
            text: '',
            id: 1,
            // 对话列表
            lists: [
                {
                    name: '客服(机器人)',
                    text: '你好,有什么能帮到您的',
                    type: 'left',
                    id: 1
                },
            ],
            file_url: [],
            fileList: [],
            host: '/api',
        }
    },
    methods: {
        onExceedFn1() {
            this.$message.error("只能上传一个文件");
        },
        successReport1(a, b) {
            console.log(a, b)
            this.file_url = a.data;
            // this.fileList.push(a.data);
            console.log(a.data)
            this.loading = false;
            this.file_url = ''
            this.fileList = []
            if (this.answerState) {
                this.$message.error('请等待回复')
                return
            }
            this.lists.push({
                name: '我',
                text: '',
                type: 'right',
                img: a.data,
                id: Number(this.id) + 1
            })
            this.text = '';

            setTimeout(() => {
                // 机器人回复
                this.answerFn()
            }, 100);
        },
        removeReport1() {
            this.file_url = [];
            this.fileList = [];
        },
        handleRemove1() {
            this.file_url = [];
            this.fileList = [];
        },
        beforeAvatarUpload1(rawFile) { },
        closeFn() {
            this.$emit('closeFn')
        },
        askFn(type) {
            this.selectType = type
            let text = ''
            if (type == 1) {
                text = '留学'
            } else if (type == 2) {
                text = '签证'
            } else {
                text = '其他'
            }
            this.text = '你好，我想咨询关于' + text + '问题'
        },
        getChat() {
            this.$http.get('/api/chat').then(res => {
                console.log(res)
            })
        },
        subFn() {
            if (this.answerState) {
                this.$message.error('请等待回复')
                return
            }
            if (this.text) {
                this.lists.push({
                    name: '我',
                    text: this.text,
                    type: 'right',
                    id: Number(this.id) + 1
                })
                this.text = '';

                setTimeout(() => {
                    // 机器人回复
                    this.answerFn()
                }, 100);
            } else {
                this.$message.error('请输入您的问题')
            }
        },
        answerFn() {
            // 回复的字一个个的显示出来
            let text = ''
            if (this.selectType == 1) {
                text = '你好呀！留学涉及的环节比较多，比如选校选专业、语言备考、文书准备、申请流程、签证办理、资金规划等，你可以先说说你目前的需求方向'
            } else if (this.selectType == 2) {
                text = '留学签证核心是 “材料真实完整、动机明确、资金达标、流程合规”，不同国家差异较大，我将会从通用流程、热门国家要点、拒签应对三方面帮你梳理，方便你快速定位问题'
            } else if (this.selectType == 3) {
                text = '留学除了选校、签证之外，还有很多需要关注的细节，比如行前准备、海外生活、学业适应、毕业后规划这几个大方向，我给你梳理了常见的关注点，你可以看看想了解哪一块：'
            } else {
                text = '除了之前提到的选校、签证、行前准备、学业生活、毕业规划之外，留学还会涉及很多容易被忽略但至关重要的细节问题，主要集中在这几个方面:财务、法律、学业文化等'
            }
            let arr = text.split('')
            let index = 0
            let timeout = 100
            this.answerState = true
            this.lists.push({
                name: '客服(人工)',
                text: '',
                type: 'left',
                img: '',
                id: Number(this.id) + 1
            })
            let listIndex = 0
            for (let i = 0; i < this.lists.length; i++) {
                if (this.lists[i].id == this.id + 1) {
                    listIndex = i
                }
            }
            let timer = setInterval(() => {
                if (index < arr.length) {
                    this.lists[listIndex].text += arr[index]
                    index++;
                    // 文字输出后，元素跟着滚动到底部
                    this.$nextTick(() => {
                        this.$refs.lists.scrollTop = this.$refs.lists.scrollHeight
                    })
                }
            }, timeout)
            setTimeout(() => {
                this.answerState = false
                this.selectType = 0
                clearInterval(timer)
            }, timeout * arr.length)
        }
    },
    mounted() {
    },
    destroyed() {
        this.lists = [
            {
                name: '客服(机器人)',
                text: '你好,有什么能帮到您的',
                type: 'left',
                id: 1,
                img: ''
            }
        ]
    }
}
</script>
<style lang="less">
.chat {
    position: fixed;
    right: 150px;
    z-index: 99999;
    background-color: #fff;
    width: 400px;
    height: 400px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 15px 20px;
    border-radius: 10px;
    padding: 10px;
    border-top: 1px solid rgba(0, 0, 0, 0.35);
    top: 30%;

    .el-upload-list {
        display: none;
    }

    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .close {
            cursor: pointer;
        }
    }

    .list {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .name {
        font-size: 12px;
        color: #666;
    }

    .lists {
        height: calc(100% - 100px);
        overflow-y: auto;
    }

    .pic {
        width: 20px;
        height: auto;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        color: #666;
        cursor: pointer;
        font-size: 18px;
        font-weight: 300;
        line-height: 0.1;
        flex-shrink: 0;
        box-sizing: border-box;
    }

    .text {
        border-radius: 4px;
        padding: 4px;
        font-size: 13px;
    }

    .right-list {
        text-align: right;

        .text {
            display: inline-block;
            background-color: #1a8c27;
            color: #fff;
        }
    }

    .left-list {
        .text {
            display: inline-block;
            background-color: #f1f1f1;
        }
    }

    .context {
        display: flex;
        align-items: center;
        padding-top: 30px;
        box-sizing: border-box;
        position: relative;

        .tips {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            font-size: 12px;
            display: flex;

            span {
                padding: 2px 10px;
                border: 1px solid #666;
                margin-right: 5px;
                border-radius: 4px;
                color: #333;
                transition: .2s all;
                cursor: pointer;
                background-color: #f1f1f1;
            }

            span:hover {
                background-color: #e0dfdf;
            }
        }

        .btn {
            flex-shrink: 0;
            margin-left: 10px;
            color: #222222;
            cursor: pointer;
            font-size: 14px;
        }
    }
}
@media (max-width: 899px) {
    .chat{
        right: 10px;
        left: 10px;
        width: auto;
        height: 400px;
        box-sizing: border-box;
        background-color: #faf9f7;
        top: 20%;
    }

    .context {
        padding-top: 25px;

        .tips {
            font-size: 11px;

            span {
                padding: 2px 8px;
                font-size: 11px;
            }
        }

        .pic {
            width: 18px;
            margin-left: 8px;
        }

        .btn {
            font-size: 13px;
            margin-left: 8px;
        }
    }

    .lists {
        height: calc(100% - 90px);
    }

    .text {
        font-size: 12px;
        padding: 3px;
    }

    .name {
        font-size: 11px;
    }
}

/* 响应式适配：小屏幕设备 */
@media (max-width: 480px) {
    .chat {
        height: 350px;
        top: 15%;
    }

    .lists {
        height: calc(100% - 80px);
    }

    .context {
        padding-top: 20px;

        .tips {
            span {
                padding: 2px 6px;
                font-size: 10px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/zh/chat.vue